<div class="data-experience">
  <!-- <button (click)="modifyLayout()">modifica layout</button>
    <button (click)="associateFrame()">associa frame</button> -->
  <div class="top-bar">
    <div class="column">

    </div>
    <div class="period-container">
      <ng-container *ngIf="showNoteButton">
        <button mat-flat-button color="primary" style="margin-right: 20px;" class="note-button"
          [matMenuTriggerFor]="viewGeneralNotes" #viewGeneralNotesTrigger="matMenuTrigger">
          <mat-icon [svgIcon]="'note'"></mat-icon>
          <span *ngIf="dataExperienceNotesListTotal === 1">
            {{dataExperienceNotesListTotal}} {{'note' | translate | uppercase}}
          </span>
          <span *ngIf="dataExperienceNotesListTotal !== 1">
            {{dataExperienceNotesListTotal}} {{'notes' | translate |uppercase}}
          </span>
          <mat-icon style="margin-left: 10px;" *ngIf="showNotePinnedIcon" [svgIcon]="'pin_circle'"></mat-icon>
        </button>

        <!-- general notes -->
        <mat-menu #viewGeneralNotes="matMenu">
          <div class="note-container-mat-panel">
            <is-note-list [notesListTotal]="dataExperienceNotesListTotal" [notesList]="dataExperienceNotesList"
              [dataExperienceGeneralNotes]="true" [showSpinner]="showNoteSpinner" (editNoteEmitter)="editNote($event)"
              (deleteNoteEmitter)="deleteNote($event)" (newGeneralNoteEmitter)="createNote($event)"
              (changeRefferedToEmitter)="changeRefferedToGeneralNote($event)"
              (changeHighlightedEmitter)="editNote($event)" (exportExcelEmitter)="exportNoteList($event)"
              (emitOpenFullscreen)="openGeneralNoteFullscreen($event)">
            </is-note-list>
            <div class="show-more-container">
              <button *ngIf="showOthersButtonGeneralNotes" mat-button color="primary"
                (click)="loadOthersGeneralNotes($event)">
                <mat-icon svgIcon="arrow_down"></mat-icon>
                <span>{{ "show_more" | translate }}</span>
              </button>
            </div>
          </div>
        </mat-menu>
      </ng-container>

      <!-- refresh data experience button -->
      <button mat-icon-button color="primary" (click)="refreshDataExperience()" style="margin-right: 10px;"
        matTooltip="{{'refresh_dataexperience' | translate}}" matTooltipPosition="above">
        <mat-icon svgIcon="refresh"></mat-icon>
      </button>

      <!-- refresh default period button -->
      <button mat-icon-button color="primary" (click)="restoreDefaultPeriod()" style="margin-right: 10px;"
        matTooltip="{{'restore_default_period' | translate}}" matTooltipPosition="above">
        <mat-icon svgIcon="update_time"></mat-icon>
      </button>

      <is-period-navigator [layout]="'lefty'" [frequencyAppearance]="'outline'" [justify]="'flex-start'"
        [yearly]="yearly" [isDarkTheme]="isDarkTheme" [frequencyControl]="defaultFrequency"
        [dateControl]="defaultDateControl" [rangeControl]="defaultRangeControl" [choiceSet]="defaultChoiceSet">
        <div>
          <mat-form-field style="margin-right: 20px" *ngIf="showEntityPicker" floatLabel="never" appearance="outline">
            <mat-label style="color:#000000DE">{{ 'entity' | translate }}</mat-label>
            <mat-select (selectionChange)="changeEntity($event)" [formControl]="entitySelectControl"
              style="color:#000000DE">
              <mat-option>
                <ngx-mat-select-search placeholder="Search" ngModel (ngModelChange)="filterEntity($event)"
                  placeholderLabel="search entity" noEntriesFoundLabel="">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let option of entitiesListForSearch" [value]="option">
                {{ option.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </is-period-navigator>
    </div>

  </div>

  <!-- grid of data experience -->
  <gridster [options]="options">
    <gridster-item [item]="item" *ngFor="let item of layout; index as i">
      <ng-container *ngIf="showGrid">
        <!-- NOTES -->
        <ng-container *ngIf="showNoteButton && framesNotesList[item?.frame?.id]?.showNoteChart">
          <!-- view notes -->
          <ng-container
            *ngIf="framesNotesList[item?.frame?.id] && framesNotesList[item?.frame?.id]?.notesListTotal !== 0">
            <button mat-mini-fab color="primary" class="view-note-button"
              [matTooltip]="'view_notes_data_experience' | translate" matTooltipPosition="left"
              [matMenuTriggerFor]="viewFramesNotes" #viewFramesNotesTrigger="matMenuTrigger">
              <mat-icon [svgIcon]="'note'" style="height: 18px; width: 18px"></mat-icon>
              <span style="width: 100%; margin-left: 0;">
                {{framesNotesList[item?.frame?.id]?.notesListTotal || 0}}
              </span>
            </button>
            <mat-menu #viewFramesNotes="matMenu">
              <div class="note-container-mat-panel">
                <is-note-list [notesListTotal]="framesNotesList[item?.frame?.id]?.notesListTotal || 0"
                  [notesList]="framesNotesList[item?.frame?.id]?.notesList || []" [dataExperienceGeneralNotes]="false"
                  [showSpinner]="framesNotesList[item?.frame?.id]?.showSpinner || false"
                  (editNoteEmitter)="editNote($event, item.frame.id)"
                  (deleteNoteEmitter)="deleteNote($event, item.frame.id)" (exportExcelEmitter)="exportNoteList($event)"
                  (emitOpenFullscreen)="openFrameNoteFullscreen($event, item?.frame?.id, item)"></is-note-list>
                <div class="show-more-container">
                  <button *ngIf="framesNotesList[item?.frame?.id]?.showOthersButton" mat-button color="primary"
                    (click)="loadOthersFramesNotes($event, item?.frame?.id)">
                    <mat-icon svgIcon="arrow_down"></mat-icon>
                    <span>{{ "show_more" | translate }}</span>
                  </button>
                </div>
              </div>
            </mat-menu>
          </ng-container>
          <!-- add note -->
          <button mat-mini-fab color="#ffffff" class="add-note-button"
            [matTooltip]="'add_note_data_experience' | translate" matTooltipPosition="left"
            #addNoteTrigger="matMenuTrigger" [matMenuTriggerFor]="addNotes" *ngIf="checkPermission('dataexperience.add_note')">
            <mat-icon color="primary" [svgIcon]="'add_note'"></mat-icon>
          </button>
          <mat-menu #addNotes="matMenu">
            <div class="create-note-container-mat-panel">
              <is-create-note (createNote)="createNote($event, item.frame.id)"
                (cancelNote)="closeCreateNewNoteBuildingBlock($event)"></is-create-note>
            </div>
          </mat-menu>
        </ng-container>

        <!-- showgrid prevent the "chhose a rebecca world" flashing -->
        <iframe [src]="item.frame?.chartUrl | safe" id="{{i}}" *ngIf="item.frame?.chartUrl"></iframe>
        <is-create-frame *ngIf="!item.frame?.chartUrl" (selected)="getDataExperienceDetail()" [item]="item"
          [currentDataExperience]="currentDataExperience" [worldsList]="worldsList" [position]="(i+1)">
        </is-create-frame>
      </ng-container>
    </gridster-item>
  </gridster>
</div>